// extracted by mini-css-extract-plugin
export default {"container":"settings_container__oDTFN","spacer70":"settings_spacer70__6E0RX","hidden":"settings_hidden__5dPRJ"};